// extracted by mini-css-extract-plugin
export default {"Editor":"RichTextEditor_Editor__mV7iY","EditorContent":"RichTextEditor_EditorContent__yyow5"};